import * as React from 'react';
import Icon from '../../../../icons/Icon';

export default class IconArrows extends Icon {
    renderIcon() {
        return (
            <svg width={this.getSize()} height={this.getSize()} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 9L14.5 14L9.5 19" stroke="#4D5E80" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.5 9L19.5 14L14.5 19" stroke="#4D5E80" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#505E7F"/>
            </svg>
        );
    }
}

